// extracted by mini-css-extract-plugin
export default {"noninteractive":"wDxh1ztBgt_pdp","inListButton":"S7PQuZ6bWt_pdp","inListButtonActive":"aQbKnH1iCB_pdp","reset":"L3Uyo1jR1S_pdp","wishlistText":"Kfe7BuVjFe_pdp"};